import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_NUEVO, ESTILO_BOTON_MODAL_ACEPTAR } from "../../utils/const/estilos-const";
import ModalConfirmar from "../../components/modal-confirmar";
import "../../style/style-cargando.css";
import ArrowBack from "../../components/arrow-back";
import cargandoCard from "../../components/cargando-card";
import sinAccesoCard from "../../components/sin-acceso-card";
import { sharedMensajeConfirmacion, sharedNextPage } from "../../utils/shared-functions";
import { SELECT_HABILITADO_DESHABILITADO } from "../../utils/const/const-select-habilitado-deshabilitado";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { COLOR_VERDE_MAIN } from "../../utils/const/colors-const";
import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import { deshabilitarSubEstadosIncidente, habilitarSubEstadosIncidente, obtenerListaSubEstadosIncidente } from "../../api/api-sub-estados-incidente";

let $ = window.$;

export default function ListarSubEstadosIncidentePage
  () {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [listaElementos, setListaElementos] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);
  const [formData, setFormData] = useState(null);

  const [rowsData, setRowsData] = useState([]);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      let data = location.state;
      console.log("data");
      console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
      }
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      objEnviar.idEstadoIncidente = data?.params?.id;
      /*let obj = {};
      obj.idMenuPrimerNivel = INT_ID_MODULO_CHECKLIST;
      obj.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_ADMINISTRACION_CHECKLIST;
      obj.idMenuTercerNivel = INT_ID_TERCER_NIVEL_CHECKLIST_OPCIONES_RESPUESTA;
      let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(obj);
      let permiso = obtenerPermisos[0];
      setPermisos(permiso);
      */
      let permiso = null;
      let lista = [];

      lista = await obtenerListaSubEstadosIncidente(objEnviar, false, t);
      setRowsData(lista);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  };

  useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      const gridElement = $("#gridContainer");
      if (gridElement.length) {
        try {
          const gridInstance = gridElement.dxDataGrid("instance");
          if (gridInstance) {
            // Grid already exists, just update the data source
            gridInstance.option("dataSource", rowsData);
          } else {
            // Grid doesn't exist yet, initialize it
            inicializarGrid();
          }
        } catch (e) {
          // Grid doesn't exist yet, initialize it
          inicializarGrid();
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [rowsData]);

  const inicializarGrid = () => {
    try {
      const gridElement = $("#gridContainer");

      // Check if element exists
      if (!gridElement.length) {
        // console.warn("Grid container element not found");
        return;
      }

      // Initialize the grid
      gridElement.dxDataGrid({
        dataSource: rowsData,
        paging: {
          pageSize: 20,
        },
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [50, 100, 150, 200],
        },
        remoteOperations: false,
        groupPanel: { visible: true },
        grouping: {
          autoExpandAll: false,
        },
        allowColumnReordering: true,
        rowAlternationEnabled: true,
        showBorders: true,
        columnAutoWidth: true,
        filterRow: {
          visible: true,
          applyFilter: "auto",
        },
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: t("grilla_placeholderbuscar"),
        },
        export: {
          enabled: true,
        },
        headerFilter: {
          visible: true,
        },
        columns: [
          {
            dataField: "acciones",
            caption: t("column_acciones"),
            width: 350,
            allowFiltering: false,
            allowSorting: false,
            cellTemplate: function (container, options) {
              // console.log("cellTemplate acciones");
              // console.log('options', options);
              // console.log('options.data', options.data);
              const buttonContainer = $("<div>").addClass("flex gap-2");
              // Edit button
              $("<button>")
                .addClass(
                  "px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm"
                )
                .text(t("column_modificar"))
                .on("click", function () {
                  modificarElementoSelected(options.data);
                })
                .appendTo(buttonContainer);

              // Delete button
              if (options.data.habilitado === 1) {
                $("<button>")
                  .addClass(
                    "px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-sm"
                  )
                  .text(t("column_deshabilitar"))
                  .on("click", function () {
                    cambiarEstadoDeshabilitar(options.data);
                  })
                  .appendTo(buttonContainer);
              }
              if (options.data.habilitado === 0) {
                $("<button>")
                  .addClass(
                    `px-3 py-1 bg-[${COLOR_VERDE_MAIN}] hover:bg-[#006600] text-white rounded text-sm`
                  )
                  .text(t("column_habilitar"))
                  .on("click", function () {
                    cambiarEstadoHabilitar(options.data);
                  })
                  .appendTo(buttonContainer);
              }

              buttonContainer.appendTo(container);
            },
          },
          {
            dataField: "id",
            caption: "ID",
            visible: false,
          },
          {
            dataField: "idEstadoIncidente",
            caption: "IDESTADOINCIDENTE",
            visible: false,
          },
          {
            dataField: "codigo",
            caption: t("column_codigo"),
            visible: true,
          },
          {
            dataField: "descripcion",
            caption: t("column_descripcion"),
            visible: true,
          },
          {
            dataField: "nota",
            caption: t("column_nota"),
            width: 150,
          },
          {
            dataField: "fechaProceso",
            caption: t("column_fechaProceso"),
            width: 200,
          },
          {
            dataField: "habilitadoLabel",
            caption: t("column_estado"),
            width: 200,
          }
        ],
      });
    } catch (err) {
      console.error("Error initializing grid:", err);
    }
  };

  const modificarElementoSelected = (data) => {
    try {
      // console.log("modificarElementoSelected");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = t("label_modificar_sub_estado_incidente");
      obj.params = data;
      obj.formData = formData;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("sub-estado-incidente", obj, history);
    } catch (err) {
      console.log("modificarElementoSelected err");
      console.log(err);
    }
  };

  const cambiarEstadoDeshabilitar = async (data) => {
    try {
      // console.log("cambiarEstadoDeshabilitar");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoDeshabilitar err");
      console.log(err);
    }
  };

  const cambiarEstadoHabilitar = async (data) => {
    try {
      // console.log("cambiarEstadoHabilitar");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoHabilitar err");
      console.log(err);
    }
  };

  const handleNuevoClick = () => {
    // console.log("handleNuevoClick");
    let obj = {};
    let data = {};
    data.id = 0;
    data.codigo = "";
    data.descripcion = "";
    data.nota = "";
    obj.titulo = t("label_crear_sub_estado_incidente");
    obj.params = data;
    obj.formData = formData;
    sharedNextPage("sub-estado-incidente", obj, history);
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleConfirmModalDeshabilitar = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    setProcessingVisible(true);
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await deshabilitarSubEstadosIncidente(objEnviar);
      setProcessingVisible(false);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_deshabilito_correctamente"));
        reset();
      }
      if (response.error === true) {
        showToast(response.message, "error", 3000);
      }
    }
  };

  const handleConfirmHabilitarModal = async () => {
    setModalConfirmarHabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await habilitarSubEstadosIncidente(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_habilito_correctamente"), "success", 3000);
        reset();
      }
      if (response.error === true) {
        showToast(response.message, "error", 3000);
      }
    }
  };

  const handleAtrasClick = () => {
    history.goBack();
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                <ArrowBack onClick={handleAtrasClick} />
                <h2 className="text-xl font-bold text-gray-900">{t("label_gestionar_sub_estados_incidente")}:{formData?.descripcion}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_administra_la_lista_de_sub_estados_incidente")}</p>
            </div>
            <div className="flex items-center gap-2">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={() => {
                  handleNuevoClick();
                }}
              >
                {t("label_nuevo")}
              </button>
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                {t("label_estado")}
              </label>
              <Select options={SELECT_HABILITADO_DESHABILITADO} isSearchable='true'
                isClearable='true'
                value={habilitadoSelected}
                onChange={(event) => setHabilitadoSelected(event)}
                placeholder={t("placeholder_seleccione_estado")}
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                &nbsp;
              </label>
              <button
                type="button"
                className={ESTILO_BOTON_MODAL_ACEPTAR}
                onClick={() => { reset(); }}
              >
                {t("label_buscar")}
              </button>
            </div>
          </div>
          <br />
          {/* Grid Card */}
          <div className="bg-white border border-gray-200 rounded-lg p-2">
            <div className="min-h-[400px]">
              <div
                id="gridContainer"
                style={{
                  height: "100%",
                  width: "100%",
                }}
              />
            </div>
          </div>
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleConfirmModalDeshabilitar}
            message={sharedMensajeConfirmacion(t("alert_esta_de_deshabilitar"), elementoSelected?.descripcion)}
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
            onConfirm={handleConfirmHabilitarModal}
            message={sharedMensajeConfirmacion(t("alert_esta_de_habilitar"), elementoSelected?.descripcion)}
          />
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarPais render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
